module.exports = __webpack_public_path__ + "static/commHealth-1488019dbf1bcc6e3b48bd78a9d53fe1.jpg";